import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

interface CandidatePayload {
  JAId: string;
  MCId: string;
  email: string;
  phone: string;
  jobTitle: string;
  timestamp: number;
  expiry: number;
}

interface DecryptResponse {
  success: boolean;
  data?: {
    decryptedPayload: CandidatePayload;
    verified: boolean;
    isValid: boolean;
  };
  error?: string;
}

interface ContactCreateResponse {
  success: boolean;
  data?: {
    contact: any;
  };
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddCandidateService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Decrypt and validate candidate payload from URL
   */
  async decryptCandidatePayload(encryptedPayload: string): Promise<DecryptResponse> {
    try {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });

      const response = await firstValueFrom(
        this.http.post<DecryptResponse>(
          `${this.apiUrl}/api/add-candidate/decrypt`,
          { encryptedPayload },
          { headers }
        )
      );

      return response;
    } catch (error: any) {
      console.error('Error decrypting candidate payload:', error);
      return {
        success: false,
        error: error.error?.error || error.message || 'Failed to decrypt candidate data'
      };
    }
  }

  /**
   * Create contact from candidate data
   */
  async createContactFromCandidate(candidateData: CandidatePayload): Promise<ContactCreateResponse> {
    try {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });

      const response = await firstValueFrom(
        this.http.post<ContactCreateResponse>(
          `${this.apiUrl}/api/add-candidate/create-contact`,
          {
            JAId: candidateData.JAId,
            email: candidateData.email,
            phone: candidateData.phone,
            jobTitle: candidateData.jobTitle,
            mcId: candidateData.MCId
          },
          { headers }
        )
      );

      return response;
    } catch (error: any) {
      console.error('Error creating contact from candidate:', error);
      return {
        success: false,
        error: error.error?.error || error.message || 'Failed to create contact'
      };
    }
  }
}